import React, { Component } from "react";
import { connect } from "react-redux";
import { checkIsMobileStatus } from "../../_actions/appActions";

class TldrMobileState extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.props.checkIsMobileStatus();
  };

  render() {
    return <></>;
  }
}

const mapStateToProps = (state) => ({
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  checkIsMobileStatus: () => dispatch(checkIsMobileStatus()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TldrMobileState);
